var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "teacher-select" },
    [
      _c(
        "el-select",
        _vm._g(
          _vm._b(
            {
              staticClass: "teacher-select__select",
              class: { "is-multiple": _vm.multiple },
              attrs: {
                filterable: "",
                multiple: _vm.multiple,
                "collapse-tags": _vm.multiple,
                remote: "",
                clearable: "",
                placeholder: _vm.placeholder,
                "remote-method": _vm.remoteMethod,
                loading: _vm.loading,
                "reserve-keyword": _vm.multiple,
              },
              on: { clear: _vm.handleClear },
              model: {
                value: _vm.val,
                callback: function ($$v) {
                  _vm.val = $$v
                },
                expression: "val",
              },
            },
            "el-select",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value },
          })
        }),
        1
      ),
      _vm.multiple && _vm.selectedItems.length
        ? _c(
            "el-popover",
            {
              attrs: {
                "popper-class": "teacher-select__popover",
                placement: "top",
                trigger: "hover",
              },
            },
            [
              _c(
                "div",
                { staticClass: "teacher-select__popover-list" },
                _vm._l(_vm.selectedItems, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.value,
                      staticClass: "teacher-select__popover-item",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "teacher-select__popover-label",
                          attrs: { title: item.label },
                        },
                        [_vm._v(" " + _vm._s(item.label) + " ")]
                      ),
                      _c("i", {
                        staticClass:
                          "el-icon-close teacher-select__popover-remove",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRemoveSelected(item.value)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
              _c("i", {
                staticClass: "el-icon-view teacher-select__eye",
                attrs: { slot: "reference" },
                slot: "reference",
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }